import { render, staticRenderFns } from "./LogoEtos.vue?vue&type=template&id=37c9db14"
import script from "./LogoEtos.vue?vue&type=script&lang=js"
export * from "./LogoEtos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports